import styles from "./index.css";
import PropTypes from "prop-types";

const Title = ({ titleText }) => <h1 className={styles.header}>{titleText}</h1>;

Title.propTypes = {
  titleText: PropTypes.string.isRequired
};

export default Title;
